<script setup lang="ts">
    import { onMounted, inject } from 'vue';
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';
    import { ChangelogAccess } from '@views/Changelog/Changelog.access';
    import Loading from '@shared/components/Loading.vue';
    import BsAlert from '@shared/components/BsAlert.vue';
    import { AlertTypes } from '@shared/components/BsAlerts';

    const injectorAccess = inject(injectorAccessInjectionKey)!;
    const changelogAccess: ChangelogAccess = injectorAccess.injector.get(ChangelogAccess);

    onMounted(async () => {
        await changelogAccess.loadChangelog();
    });
</script>

<template>
    <div class="container max-700">
        <h1>{{ $Resources.ChangelogLabel }}</h1>

        <template v-if="changelogAccess.state.posts.length > 0">
            <div v-for="post in changelogAccess.state.posts" :key="post.Id">
                <h2>
                    {{ post.Title.Rendered }}
                </h2>
                <div v-html="post.Content.Rendered"></div>
                <hr />
            </div>
        </template>

        <BsAlert
            class="m-lg-t"
            v-if="!changelogAccess.state.loading && changelogAccess.state.posts.length === 0"
            :type="AlertTypes.Info"
            :dismissible="false"
            :content="$Resources.NoEntriesAlertContent" />

        <Loading :show="changelogAccess.state.loading" />
    </div>
</template>

